export type Temoignage = {
  /** Prénom (et initiale du nom si vous le souhaitez) */
  prenom: string
  /** Formation suivie, ex. "BTS NDRC — 2e année" */
  formation: string
  /** Entreprise d'accueil, ou "" si l'apprenant ne souhaite pas la citer */
  entreprise?: string
  /** Le témoignage lui-même, 2 à 4 phrases suffisent */
  citation: string
}

/**
 * ⚠️ STRUCTURE PRÊTE À REMPLIR.
 * Ajoutez ici les témoignages écrits de vos apprenants ou de vos entreprises
 * partenaires : c'est la preuve la plus efficace auprès des futurs candidats
 * et de leurs parents. Tant que ce tableau est vide, la section n'apparaît
 * pas sur le site — aucun risque d'afficher un bloc incomplet.
 *
 * Pensez à recueillir l'accord écrit de la personne avant publication (RGPD).
 *
 * Exemple :
 * {
 *   prenom: 'Imane',
 *   formation: 'BTS NDRC — 1re année',
 *   entreprise: 'Nom de l’entreprise',
 *   citation: "L'équipe m'a aidée à trouver mon entreprise en trois semaines...",
 * },
 */
export const TEMOIGNAGES: Temoignage[] = []
